<template>
    <div>
        <v-dialog v-model="visible" transition="dialog-top-transition" scrollable persistent max-width="700">
            <v-card class="modal-maincard">

                <v-toolbar dark flat dense>
                    <v-toolbar-title>{{this.title}}</v-toolbar-title>
                </v-toolbar>

                <v-card-text class="wrapperFormModal">
                    <v-card flat>
                        <v-card-text>
                            
                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Наименование_каз") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="text-field-with-icon">
                                        <v-text-field
                                            v-model="options.nameKz"
                                            hide-details
                                            required
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </div>
                                </v-col>
                            </v-row>

                            <v-row no-gutters>
                                <v-col cols="12" sm="12" md="3">
                                    <label class="f-label">{{ $t("Наименование_рус") }}</label>
                                </v-col>
                                <v-col cols="12" sm="12" md="9">
                                    <div class="text-field-with-icon">
                                        <v-text-field
                                            v-model="options.nameRu"
                                            hide-details
                                            required
                                            outlined
                                            dense
                                        ></v-text-field>
                                    </div>
                                </v-col>
                            </v-row>

                        </v-card-text>
                    </v-card>
                </v-card-text>

                <v-card-actions>
                    <v-spacer></v-spacer>

                    <v-btn 
                        color="cyan"
                        text
                        depressed 
                        @click="onSave"
                        v-if="options.nameKz && options.nameRu"
                    >
                        {{ options.new ? $t("Добавить") : $t("Сохранить") }}
                    </v-btn>

                    <v-btn
                        v-if="!options.new"
                        color="red"
                        text
                        depressed 
                        @click="onDelete"
                    >
                        {{ $t("Удалить") }}
                    </v-btn>

                    <v-btn 
                        color="blue-grey"
                        text 
                        depressed 
                        @click="onCancel"
                    >
                        {{ $t("Закрыть") }}
                    </v-btn>

                </v-card-actions>

            </v-card>
        </v-dialog>
    </div>
</template>

<script>

export default {
    name: "CreateBoard",
    computed: {
        title() {
            return this.options.new ? this.$t("Добавить_доску") : this.$t("Редактировать_доску");
        }
    },
    data () {
        return {
            visible: false,
            resolve: null,
            reject: null,

            options: { color: 'grey lighten-3', width: 400, zIndex: 200, noconfirm: false, nameKz: null, nameRu: null, new: null }
        }
    },
    methods: {
        async open(options = {})
        {
            this.visible = true;
            this.options = Object.assign(this.options, options);

            return new Promise((resolve, reject) => {
                this.resolve = resolve;
                this.reject = reject;
            });
        },        
        onSave() {
            this.visible = false;
            this.resolve({ delete: false, name: { 'kk-KZ': this.options.nameKz, 'ru-RU': this.options.nameRu } });
            this.resetOptions();
        },
        onDelete() {
            this.visible = false;
            this.resolve({ delete: true });
            this.resetOptions();
        },
        onCancel() {
            this.visible = false;
            this.resetOptions();
            this.reject({ isCancelled: true, message: "Действие_отменено" });
        },
        resetOptions() {
            this.options = { color: 'grey lighten-3', width: 400, zIndex: 200, noconfirm: false, nameKz: null, nameRu: null, new: null };
        }
    }
}
</script>